import React, { Component } from "react";
import uniqBy from "lodash/uniqBy";
import flatMap from "lodash/flatMap";
import {
  AvatarUpdate,
  BreadcrumbContainer,
  BreadcrumbButton,
  Button,
  FormSection,
  Input,
  Label,
  PricingTable,
  PricingTableItem,
  Progress,
  InputGroup,
  Radio,
  Divider as DefaultDivider,
  LabelContainer,
  LabelHint,
  Select,
  Text,
  Textarea,
} from "prospect-path-components";
import styled from "styled-components";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import PlanModal from "../../components/product-management/overview/plan-modal";
import RadioContainer from "../../components/product-management/radio-container";
import Heading from "../../components/product-management/heading";
import DataGroupChecklist from "../../components/product-management/data-group-checklist";
import ScreenshotUpload from "../../components/product-management/screenshot-upload";
import ProductLogo from "../../components/product-management/product-logo";
import AutosuggestTagPicker from "../../components/product-management/autosuggest-tag-picker";
import ErrorText from "../../components/product-management/ErrorText";

import BreadcrumbWrapper from "../../components/product-management/layout/breadcrumb-wrapper";
import HeadingContainer from "../../components/product-management/layout/heading-container";
import SubContainer from "../../components/product-management/layout/sub-container";

import { history } from "../../store";

import getTeamProduct from "../../actions/product-management/GetTeamProduct";
import publishProduct from "../../actions/product-management/PublishProduct";
import convertErrorsToObject from "../../tools/convert-errors-to-object";
import pick from "../../tools/pick";
import moment from "moment";

const Divider = styled(DefaultDivider)`
  margin: 1rem 0;
`;

const SuccessText = styled(Text)`
  width: 100%;
  background-color: rgba(180, 248, 0, 0.1);
  color: #369e01;
  padding: 0.375rem 1rem;
  border-radius: 18px;
`;

class ProductOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      pricingModalOpen: false,
      pricingModalPlanIndex: null,
      data: {
        name: "",
        product_logo: "",
        description: "",
        screenshots: [],
        customers_section_url: "",
        mobile_application_urls: [],
        primary_category: [],
        primary_category_id: null,
        additional_categories: [],
        features: [],
        data_values: {},
        plans: [],
      },
      saveDraftSuccess: false,
    };

    this.submitPublished = this.submitPublished.bind(this);
    this.submitDraft = this.submitDraft.bind(this);
    this.handleDataGroups = this.handleDataGroups.bind(this);
    this.handleScreenshots = this.handleScreenshots.bind(this);
    this.handleProductLogo = this.handleProductLogo.bind(this);
    this.getPrimaryCategory = this.getPrimaryCategory.bind(this);
    this.getAdditionalCategoryIds = this.getAdditionalCategoryIds.bind(this);
    this.getTeam = this.getTeam.bind(this);
    this.isReadOnly = this.isReadOnly.bind(this);
    this.getSuggestions = this.getSuggestions.bind(this);
    this.getCategoryDataValues = this.getCategoryDataValues.bind(this);
    this.filterDataValues = this.filterDataValues.bind(this);
    this.filterDataValuesForSubmit = this.filterDataValuesForSubmit.bind(this);
    this.handleSetPrimaryCategory = this.handleSetPrimaryCategory.bind(this);
    this.handleAdditionalTags = this.handleAdditionalTags.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleMobileAppIdChange = this.handleMobileAppIdChange.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.addPricingPlan = this.addPricingPlan.bind(this);
    this.updatePricingPlan = this.updatePricingPlan.bind(this);
    this.editPricingPlan = this.editPricingPlan.bind(this);
    this.deletePricingPlan = this.deletePricingPlan.bind(this);
    this.openPricingModal = this.openPricingModal.bind(this);
    this.closePricingModal = this.closePricingModal.bind(this);
    this.getFeatureDataValues = this.getFeatureDataValues.bind(this);
    this.getDataGroupsFromSlugs = this.getDataGroupsFromSlugs.bind(this);
    this.hasDataValuesFromSlugs = this.hasDataValuesFromSlugs.bind(this);
    this.renderDataGroupsFromSlugs = this.renderDataGroupsFromSlugs.bind(this);
    this.mobileAppFieldHidden = this.mobileAppFieldHidden.bind(this);
    this.mobileAppField = this.mobileAppField.bind(this);
    this.getErrorsForPricingPlan = this.getErrorsForPricingPlan.bind(this);
    this.pricingPlanHasErrors = this.pricingPlanHasErrors.bind(this);
  }
  componentDidMount() {
    const teamId = this.getTeamId();
    const productId = this.getProductId();

    this.props.getTeamProduct(teamId, productId);

    window.scrollTo(0, 0);

    document.title = "Overview | Prospect Path";
  }
  componentWillReceiveProps(nextProps) {
    const product = nextProps.products.find(
      (product) => product.id === this.getProductId()
    );
    const { dataGroups } = nextProps;
    const { data } = this.state;
    const { data_values } = data;

    if (product && dataGroups.length && Object.keys(data_values).length === 0) {
      data.data_values = Object.values(product.data_values).reduce(
        (dataValues, dataValue) => {
          const dataGroup = dataGroups.find(
            (group) =>
              group.values.filter((value) => value.id === dataValue.id).length
          );

          if (!dataValues[dataGroup.id]) {
            dataValues[dataGroup.id] = [];
          }

          dataValues[dataGroup.id].push(dataValue);

          return dataValues;
        },
        {}
      );
      this.setState({ data });
    }

    if (product !== undefined && this.state.loaded === false) {
      const {
        name,
        description,
        primary_software_category_id,
        primary_software_category,
        additional_categories,
        plans,
        product_logo,
        screenshot_urls,
        mobile_application_urls,
      } = product;

      // Use vendor domain logo as product logo if there is not one one the product
      let productLogo = product_logo;
      if (
        product_logo === null ||
        product_logo === undefined ||
        product_logo === ""
      ) {
        productLogo = nextProps.vendor.clearbit_logo;
      }

      const formattedPlans = plans.map((plan) => {
        plan.features = Object.values(plan.features);

        return plan;
      });

      const updatedData = {
        ...data,
        name,
        description,
        primary_category_id: primary_software_category_id,
        primary_category: primary_software_category
          ? [primary_software_category]
          : [],
        additional_categories: Object.values(additional_categories),
        plans: formattedPlans,
        product_logo: productLogo,
        screenshots: screenshot_urls,
        mobile_application_urls,
      };

      this.setState({ loaded: true, data: updatedData });
    }
  }
  // Remove any data values which aren't valid for the selected categories
  filterDataValuesForSubmit(dataValues) {
    const selectedCategories = this.getSelectedCategories();

    // This will include data values for individual data value / category links but not
    // data group / category associations if the handle_categories_at_group_level flag is set
    const allowedDataValues = this.getCategoryDataValues();

    const outputDataValues = {};

    Object.keys(dataValues).forEach((groupId) => {
      const group = this.props.dataGroups.find(
        (dataGroup) => dataGroup.id === parseInt(groupId)
      );
      if (group !== undefined) {
        if (group.handle_categories_at_group_level) {
          // Check whether one of the selected categories is present
          let found = false;
          selectedCategories.forEach((selectedCategory) => {
            if (
              group.categories
                .map((category) => category.id)
                .includes(selectedCategory.id)
            ) {
              found = true;
            }
          });

          if (found) {
            outputDataValues[groupId] = dataValues[groupId];
          }
        } else {
          outputDataValues[groupId] = dataValues[groupId].filter((dataValue) =>
            allowedDataValues
              .map((allowedValue) => allowedValue.id)
              .includes(dataValue.id)
          );
        }
      }
    });

    return outputDataValues;
  }
  mapStateForSubmit() {
    const { data } = this.state;
    const {
      name,
      screenshots,
      product_logo,
      description,
      primary_category_id,
      mobile_application_urls,
      plans,
      data_values,
    } = data;
    const additional_category_ids = this.getAdditionalCategoryIds();

    const filteredDataValues = this.filterDataValuesForSubmit(data_values);

    return {
      name,
      screenshots,
      product_logo,
      description,
      primary_category_id,
      additional_category_ids,
      mobile_application_urls,
      pricing: this.mapPricingForSubmit(plans),
      data_value_ids: flatMap(Object.values(filteredDataValues)).map(
        (dataValue) => dataValue.id
      ),
    };
  }
  mapPricingForSubmit(plans) {
    const output = plans.map(({ features, ...plan }) => ({
      features: features.map((feature) => feature.id),
      ...plan,
      currency:
        plan.currency === null || plan.currency === undefined
          ? "USD"
          : plan.currency,
    }));

    return output;
  }
  submitPublished() {
    const teamId = this.getTeamId();
    const productId = this.getProductId();

    const data = this.mapStateForSubmit();
    const action = "publish";

    this.props
      .publishProduct(teamId, productId, { ...data, action })
      .then((success) => {
        if (success) {
          history.push(
            `/products/${this.props.match.params.product_id}/promote`
          );
        } else {
          window.scrollTo(0, 0);
        }
      });
  }
  submitDraft() {
    const teamId = this.getTeamId();
    const productId = this.getProductId();

    const data = this.mapStateForSubmit();
    const action = "draft";

    // Remove save draft success message if it is currently being displayed
    this.setState({
      saveDraftSuccess: false,
    });

    this.props
      .publishProduct(teamId, productId, { ...data, action })
      .then((success) => {
        if (success) {
          this.setState({
            saveDraftSuccess: true,
          });
          window.scrollTo(0, 0);
        } else {
          this.setState({
            saveDraftSuccess: false,
          });
          window.scrollTo(0, 0);
        }
      });
  }
  errorsForField(field) {
    const errors = [];
    Object.keys(this.props.errors).forEach((key) => {
      if (key.split(".")[0] === field) {
        errors.push(this.props.errors[key]);
      }
    });

    if (errors.length > 0) {
      return errors.map((error) => <ErrorText>{error}</ErrorText>);
    }

    return "";
  }
  handleDataGroups(id, checkedItems) {
    const { data } = this.state;
    const dataValueIds = data.data_values;
    dataValueIds[id] = checkedItems;

    data.data_values = dataValueIds;

    this.setState({ data });
  }
  handleScreenshots(screenshots) {
    const { data } = this.state;
    data.screenshots = screenshots;

    this.setState({ data });
  }
  handleProductLogo(logoUrl) {
    const { data } = this.state;
    data.product_logo = logoUrl;

    this.setState({ data });
  }
  getPrimaryCategory() {
    const categoryId = this.state.data.primary_category_id;

    if (categoryId === null) {
      return null;
    }

    return this.props.categories.find(
      (category) => parseInt(categoryId) === category.id
    );
  }
  getAdditionalCategoryIds() {
    return this.state.data.additional_categories.map((category) => category.id);
  }
  getAvailablePrimaryCategories() {
    const additionalCategoryIds = this.getAdditionalCategoryIds();
    const categories = [
      {
        id: 0,
        name: "Please select...",
      },
    ].concat(this.props.categories);

    return categories.filter(
      (category) => !additionalCategoryIds.includes(category.id)
    );
  }
  getSelectedCategories() {
    const primaryCategory = this.getPrimaryCategory();
    const additionalCategories = this.state.data.additional_categories;
    const categories = [];

    if (primaryCategory) {
      categories.push(primaryCategory);
    }

    additionalCategories.forEach((category) => categories.push(category));

    return uniqBy(categories, (data) => data.id);
  }
  getTeamId() {
    return parseInt(this.props.currentTeamId);
  }
  isReadOnly() {
    if (this.getTeam() === null || this.getTeam() === undefined) {
      return true;
    }

    return this.getTeam().user_role === "read_only";
  }
  getTeam() {
    return this.props.teams.find((team) => team.id === this.getTeamId());
  }
  getProductId() {
    return parseInt(this.props.match.params.product_id);
  }
  getProduct() {
    const product = this.props.products.find(
      (product) => product.id === this.getProductId()
    );

    if (product !== undefined) {
      document.title = `${product.name} Overview | Prospect Path`;
    }

    return product;
  }
  getSuggestions() {
    return this.props.categories.filter(
      (category) =>
        category.id !== parseInt(this.state.data.primary_category_id)
    );
  }
  getCategoryDataValues() {
    const categories = this.getSelectedCategories();

    const dataValues = categories.reduce((values, category) => {
      category.data_values.forEach((dataValue) => {
        values.push(dataValue);
      });

      return uniqBy(values, (data) => data.id);
    }, []);

    return dataValues.sort((a, b) => (a.name > b.name ? 1 : -1));
  }
  filterDataValues(dataValues) {
    const categoryDataValues = this.getCategoryDataValues();

    return categoryDataValues.filter((categoryDataValue) => {
      const dataValueIndex = dataValues.findIndex(
        (dataValue) => dataValue.id === categoryDataValue.id
      );

      if (dataValueIndex !== -1) {
        return true;
      }

      return false;
    });
  }
  handleSetPrimaryCategory(data) {
    this.setState({
      data: {
        ...this.state.data,
        primary_category: data[data.length - 1] ? [data[data.length - 1]] : [],
        primary_category_id: data[data.length - 1]
          ? data[data.length - 1].id
          : null,
      },
    });
  }
  handleAdditionalTags(tags) {
    const data = { ...this.state.data };
    data.additional_categories = tags.filter((tag) => tag.id !== undefined);

    this.setState({ data });
  }
  handleChange(e) {
    const { data } = { ...this.state };
    const { name, value } = e.target;
    data[name] = value;

    this.setState({ data });
  }
  handleMobileAppIdChange(index, value) {
    const { data } = { ...this.state };
    let mobile_application_urls = data.mobile_application_urls;
    mobile_application_urls[index] = value;

    mobile_application_urls = mobile_application_urls.filter(
      (appId) => !(appId === "" || appId === null)
    );

    this.setState({
      data: {
        ...data,
        mobile_application_urls,
      },
    });
  }
  handleRadio(e) {
    const { data } = { ...this.state };
    const { name, value } = e.target;
    data[name] = value === "true";

    this.setState({ data });
  }
  addPricingPlan(pricingPlan) {
    const { data } = { ...this.state };
    data.plans.push(pricingPlan);

    this.setState({
      data,
      pricingModalOpen: false,
      pricingModalPlanIndex: null,
    });
  }
  updatePricingPlan(plan) {
    const { data, pricingModalPlanIndex } = { ...this.state };
    const { plans } = data;

    // Default pricing plan currency to USD
    if (plan.currency === null) {
      plan.currency = "USD";
    }

    plans.splice(pricingModalPlanIndex, 1, plan);
    data.plans = plans;

    this.setState({
      data,
      pricingModalOpen: false,
      pricingModalPlanIndex: null,
    });
  }
  editPricingPlan(index) {
    this.setState({
      pricingModalPlanIndex: index,
      pricingModalOpen: true,
    });
  }
  deletePricingPlan(index) {
    const { data } = { ...this.state };
    const { plans } = data;

    data.plans = plans.filter((plan, planIndex) => planIndex !== index);

    this.setState({ data });
  }
  openPricingModal() {
    this.setState({ pricingModalOpen: true });
  }
  closePricingModal() {
    this.setState({ pricingModalOpen: false, pricingModalPlanIndex: null });
  }
  getFeatureDataValues() {
    const dataGroup = this.props.dataGroups.find(
      (dataGroup) => dataGroup.slug === "features"
    );
    if (dataGroup === undefined) {
      return [];
    }

    return this.filterDataValues(dataGroup.values);
  }
  getDataGroupsFromSlugs(dataGroupSlugs) {
    // Filter which data groups should be shown based on category
    // For the included data groups only show for the categories in the array
    const allExceptEhr = this.props.categories
      .map((category) => category.slug)
      .filter((categorySlug) => categorySlug !== "ehr");

    const categoryDataGroupRules = {
      compliance: ["ehr"],
      industry: allExceptEhr,
      specialty: ["ehr"],
    };

    const selectedCategorySlugs = this.getSelectedCategories().map(
      (category) => category.slug
    );

    const filteredDataGroupSlugs = dataGroupSlugs.filter((dataGroupSlug) => {
      // If the data group has no rules then always show it
      if (!categoryDataGroupRules.hasOwnProperty(dataGroupSlug)) {
        return true;
      }

      // Check if the current selected category is in the array of ones which should show the value
      return (
        selectedCategorySlugs.filter((selectedCategorySlug) =>
          categoryDataGroupRules[dataGroupSlug].includes(selectedCategorySlug)
        ).length > 0
      );
    });

    return this.props.dataGroups
      .filter((dataGroup) => filteredDataGroupSlugs.includes(dataGroup.slug))
      .filter((dataGroup) => {
        if (dataGroup.handle_categories_at_group_level) {
          // Check for selected category / data group link here
          const selectedCategoryIds = this.getSelectedCategories().map(
            (category) => category.id
          );

          return (
            dataGroup.categories.filter((category) =>
              selectedCategoryIds.includes(category.id)
            ).length > 0
          );
        }

        return true;
      });
  }
  hasDataValuesFromSlugs(dataGroupSlugs) {
    const dataGroups = this.getDataGroupsFromSlugs(dataGroupSlugs);

    const numberOfDataValues = dataGroups
      .map(({ handle_categories_at_group_level, values }) => {
        if (handle_categories_at_group_level) {
          return values.length;
        }

        return this.filterDataValues(values).length;
      })
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

    return numberOfDataValues > 0;
  }
  renderDataGroupsFromSlugs(dataGroupSlugs) {
    const showSelectAllNone = ["industry"];

    return this.getDataGroupsFromSlugs(dataGroupSlugs).map(
      ({ id, name, slug, values, handle_categories_at_group_level }) => {
        if (handle_categories_at_group_level) {
          return (
            <div key={id}>
              {values.length > 0 && (
                <DataGroupChecklist
                  id={id}
                  label={name}
                  options={values.sort((a, b) => (a.name > b.name ? 1 : -1))}
                  showSelectAllNone={
                    showSelectAllNone.includes(slug) ||
                    this.filterDataValues(values) > 6
                  }
                  onChange={this.handleDataGroups}
                  defaultValues={this.state.data.data_values[id]}
                  disabled={this.isReadOnly()}
                />
              )}
            </div>
          );
        }

        return (
          <div key={id}>
            {this.filterDataValues(values).length > 0 && (
              <DataGroupChecklist
                id={id}
                label={name}
                options={this.filterDataValues(values)}
                showSelectAllNone={
                  showSelectAllNone.includes(slug) ||
                  this.filterDataValues(values) > 6
                }
                onChange={this.handleDataGroups}
                defaultValues={this.state.data.data_values[id]}
                disabled={this.isReadOnly()}
              />
            )}
          </div>
        );
      }
    );
  }
  mobileAppFieldHidden() {
    const dataValueSlugs = Object.values(this.state.data.data_values)
      .flatten()
      .map((dataValue) => dataValue.slug);

    // If there are mobile app id values present always show the field
    if (this.state.data.mobile_application_urls.length > 0) {
      return false;
    }

    return !(
      dataValueSlugs.includes("ios") || dataValueSlugs.includes("android")
    );
  }
  mobileAppField() {
    if (this.mobileAppFieldHidden()) {
      return "";
    }

    return (
      <InputGroup>
        {this.errorsForField("mobile_application_urls")}
        <LabelContainer>
          <Label>Mobile App URL</Label>
          <LabelHint>URL from apps.apple.com or play.google.com </LabelHint>
        </LabelContainer>
        {this.state.data.mobile_application_urls
          .concat(null)
          .map((mobileApplicationId, index) => (
            <Input
              value={mobileApplicationId}
              name="mobile_application_urls[]"
              key={index}
              style={{ marginBottom: "0.75rem" }}
              onChange={(e) =>
                this.handleMobileAppIdChange(index, e.target.value)
              }
              disabled={this.isReadOnly()}
            />
          ))}
      </InputGroup>
    );
  }
  getErrorsForPricingPlan(index) {
    const errors = convertErrorsToObject(this.props.errors);

    return pick(errors, ["pricing", index]) || {};
  }
  pricingPlanHasErrors(index) {
    return Object.keys(this.getErrorsForPricingPlan(index)).length > 0;
  }
  render() {
    const product = this.getProduct();
    const team = this.getTeam();

    if (this.props.user.id === null) {
      window.location = "/login?redirect=/products/";
    }

    // If the vendor is pending show the product modal rather than the overview page
    if (this.props.user.is_vendor_pending) {
      window.location = `/products?confirmProduct=${this.getProductId()}`;

      return "";
    }

    let updatedByName = "Prospect Path";
    if (
      product &&
      product.updated_by_user &&
      product.updated_by_user.role !== "super_admin"
    ) {
      if (product.updated_by_user.name !== "") {
        updatedByName = product.updated_by_user.name;
      } else {
        updatedByName = product.updated_by_user.email;
      }
    }

    return (
      <div>
        <div className="l-wrapper-content">
          <section className="l-wrapper-container">
            <header className="l-billing-header">
              <div style={{ maxWidth: "60rem" }}>
                {this.state.saveDraftSuccess ? (
                  <SuccessText>Draft saved successfully</SuccessText>
                ) : (
                  ""
                )}
                {this.props.errorMessage !== "" ? (
                  <ErrorText>{this.props.errorMessage}</ErrorText>
                ) : (
                  ""
                )}
                {this.isReadOnly() ? (
                  <ErrorText>
                    This product is read only as you do not have permission to
                    edit it.
                  </ErrorText>
                ) : (
                  ""
                )}

                <HeadingContainer>
                  <Heading>{product ? product.name : ""}</Heading>

                  <BreadcrumbWrapper>
                    <BreadcrumbContainer>
                      <BreadcrumbButton active>Overview</BreadcrumbButton>
                      <BreadcrumbButton
                        onClick={() =>
                          history.push(
                            `/products/${this.props.match.params.product_id}/promote`
                          )
                        }
                      >
                        Promote
                      </BreadcrumbButton>
                      {/* Disable the feature for now */}
                      {/* {this.props.awardsEnabled && (
                        <BreadcrumbButton
                          onClick={() => history.push(`/products/${this.props.match.params.product_id}/awards`)}
                        >
                          Awards
                        </BreadcrumbButton>)
                      } */}
                    </BreadcrumbContainer>
                  </BreadcrumbWrapper>
                </HeadingContainer>

                <SubContainer>
                  <Progress
                    progress={product ? product.completed : 0}
                    style={{ marginRight: "1rem" }}
                  />
                  <AvatarUpdate
                    name={updatedByName}
                    updatedAt={
                      product
                        ? moment(product.updated_at).format(
                            "MMMM Do YYYY, h:mm:ss a"
                          )
                        : ""
                    }
                  />
                </SubContainer>
              </div>
            </header>

            <FormSection
              heading="Product Overview"
              subheading="General details and appearance of your product."
            >
              <InputGroup>
                <Label>Product Name (Required)</Label>
                {this.errorsForField("name")}
                <Input
                  name="name"
                  disabled={this.isReadOnly()}
                  onChange={this.handleChange}
                  value={this.state.data.name}
                />
              </InputGroup>

              <InputGroup>
                <Label>Product Description</Label>
                {this.errorsForField("description")}
                <Textarea
                  name="description"
                  disabled={this.isReadOnly()}
                  onChange={this.handleChange}
                  value={this.state.data.description}
                />
              </InputGroup>

              <ProductLogo
                disabled={this.isReadOnly()}
                teamId={this.getTeamId()}
                productId={this.getProductId()}
                previewImageUrl={this.state.data.product_logo}
                onChange={this.handleProductLogo}
                product={product}
                vendor={this.props.vendor}
              />

              <InputGroup>
                <Label>Software Category (Required)</Label>
                {this.errorsForField("primary_category_id")}
                <AutosuggestTagPicker
                  suggestions={this.getSuggestions()}
                  value={this.state.data.primary_category}
                  name="primary_category_id"
                  onChange={this.handleSetPrimaryCategory}
                  tagDisplayProp="name"
                  inputProps={{ placeholder: "Start typing to search" }}
                  disabled={this.isReadOnly()}
                />
              </InputGroup>

              <InputGroup>
                <Label>Additional Categories (maximum 8)</Label>
                {this.errorsForField("additional_category_ids")}
                <AutosuggestTagPicker
                  suggestions={this.getSuggestions()}
                  value={this.state.data.additional_categories}
                  name="additional_categories"
                  onChange={this.handleAdditionalTags}
                  tagDisplayProp="name"
                  inputProps={{ placeholder: "Start typing to search" }}
                  disabled={this.isReadOnly()}
                />
              </InputGroup>

              <ScreenshotUpload
                errors={this.props.errors}
                onChange={this.handleScreenshots}
                team={team || {}}
                product={product || {}}
                screenshots={this.state.data.screenshots}
                disabled={this.isReadOnly()}
              />
            </FormSection>
            {(this.hasDataValuesFromSlugs([
              "features",
              "deployment",
              "operating-system-platform",
              "compliance",
            ]) ||
              !this.mobileAppFieldHidden()) && (
              <FormSection
                heading="Product Features"
                subheading="Your products features, OS and device support."
              >
                {this.errorsForField("data_value_ids")}
                <InputGroup>
                  {this.renderDataGroupsFromSlugs([
                    "features",
                    "deployment",
                    "operating-system-platform",
                  ])}
                </InputGroup>
                {this.mobileAppField()}
                {this.renderDataGroupsFromSlugs(["compliance"])}
              </FormSection>
            )}

            {/* Only show the support section if there are relevant fields for it */
            this.hasDataValuesFromSlugs([
              "support-services",
              "implementation-timeframe",
            ]) && (
              <FormSection
                heading="Support"
                subheading="Support and implementation services for your product."
              >
                {this.renderDataGroupsFromSlugs([
                  "support-services",
                  "implementation-timeframe",
                ])}
              </FormSection>
            )}

            {this.hasDataValuesFromSlugs([
              "customer-size",
              "industry",
              "specialty",
            ]) && (
              <FormSection
                heading="Customers"
                subheading="Customer suitability of your product."
              >
                {this.renderDataGroupsFromSlugs([
                  "customer-size",
                  "industry",
                  "specialty",
                ])}
              </FormSection>
            )}
            <FormSection
              heading="Pricing"
              subheading="Add plans for your product to appear in price comparisons."
            >
              <Label>Pricing Plans</Label>
              <PricingTable>
                {this.state.data.plans.map((plan, index) => (
                  <PricingTableItem
                    key={index}
                    number={index + 1}
                    name={plan.name}
                    onEditClicked={() => this.editPricingPlan(index)}
                    onCloseClicked={() => this.deletePricingPlan(index)}
                    hasErrors={this.pricingPlanHasErrors(index)}
                  />
                ))}
              </PricingTable>

              <Button
                onClick={this.openPricingModal}
                color="secondary"
                size="lg"
                style={{ marginTop: "1rem" }}
                disabled={this.isReadOnly()}
              >
                Add Pricing Plan
              </Button>
            </FormSection>

            <Divider />

            <div
              style={{
                display: "flex",
                maxWidth: "42.5rem",
                marginLeft: "auto",
                marginTop: "3.875rem",
              }}
            >
              <Button
                disabled={this.isReadOnly()}
                onClick={this.submitPublished}
                color="primary"
                size="lg"
                style={{ marginRight: "1.5rem" }}
              >
                Update Product
              </Button>

              <Button
                disabled={this.isReadOnly()}
                onClick={this.submitDraft}
                size="lg"
              >
                Save As Draft
              </Button>
            </div>
          </section>

          <PlanModal
            ariaHideApp={false}
            categories={this.state.data.additional_categories.concat(
              this.state.data.primary_category
            )}
            closeModal={this.closePricingModal}
            shouldFocusAfterRender={false}
            isOpen={this.state.pricingModalOpen}
            onPricingPlanAdded={this.addPricingPlan}
            onPricingPlanUpdated={this.updatePricingPlan}
            plan={
              this.state.pricingModalPlanIndex !== null
                ? this.state.data.plans[this.state.pricingModalPlanIndex]
                : null
            }
            errors={this.getErrorsForPricingPlan(
              this.state.pricingModalPlanIndex
            )}
            getFeatureDataValues={this.getFeatureDataValues}
            disabled={this.isReadOnly()}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  currentTeamId: state.teams.currentTeam,
  teams: state.teams.all,
  userTeams: state.teams.userTeams,
  loadingTeams: state.teams.loadingTeams,
  products: state.productManagement.products.all,
  categories: state.productManagement.categories.all,
  dataGroups: state.productManagement.dataGroups.all,
  pricing: state.productManagement.pricing.all,
  vendor: state.vendor.data,
  errors: state.formErrors.publishProduct,
  errorMessage: state.formErrors.message,
  awardsEnabled: state.featureFlags.ProductManagementAwards,
});

const mapDispatchToProps = (dispatch) => ({
  getTeamProduct: (teamId, productId) =>
    dispatch(getTeamProduct(teamId, productId)),
  publishProduct: (teamId, productId, data) =>
    dispatch(publishProduct(teamId, productId, data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductOverview)
);
